export default __webpack_public_path__ + "static/media/sunrise.34ff2655.svg";